export const FACEBOOK_ANALYTICS_ID = (reactAppEnv => {
  switch (reactAppEnv) {
    case 'prod':
      return '1571747739787756';
    case 'staging':
      return '412491435838201';
    default:
      return '404087473379851';
  }
})(process.env.REACT_APP_ENV);

export const CB2_FACEBOOK_ANALYTICS_ID = ((reactAppEnv) => {
  switch (reactAppEnv) {
    case 'prod':
      return '779151922131416';
    case 'staging':
      return '412491435838201';
    default:
      return '404087473379851';
  }
})(process.env.REACT_APP_ENV);

export const TIK_TOK_SERVICE_ID = ((reactAppEnv) => {
  switch (reactAppEnv) {
    case 'prod':
      return 'C381EUB521OOMP6VT010';
    case 'staging':
      return 'C39J8G8EDD9CLCSSK0JG';
    default:
      return 'C3ERBAMPKKNB3CA805I0';
  }
})(process.env.REACT_APP_ENV);
